var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5801 3.00075L18.128 3.21426V3.21426L18.5801 3.00075ZM18.5801 20.9993L19.0323 21.2128L18.5801 20.9993ZM29 12L29.1504 12.4768L30.6622 12L29.1504 11.5232L29 12ZM17.1832 1.21351L18.128 3.21426L19.0323 2.78724L18.0874 0.786487L17.1832 1.21351ZM18.128 20.7857L17.1832 22.7865L18.0874 23.2135L19.0323 21.2128L18.128 20.7857ZM28.8496 11.5232C24.0997 13.0214 20.2094 16.3783 18.128 20.7857L19.0323 21.2128C20.9915 17.0641 24.659 13.8935 29.1504 12.4768L28.8496 11.5232ZM18.128 3.21426C20.2094 7.62173 24.0997 10.9786 28.8496 12.4768L29.1504 11.5232C24.659 10.1065 20.9915 6.93595 19.0323 2.78723L18.128 3.21426ZM29 11.5L7.89248e-07 11.5L-7.89248e-07 12.5L29 12.5V11.5Z",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.ef150f95a9d4ae147d7e4a9a1b0fedc6.svg";
export { ForwardRef as ReactComponent };